import template from './headerLendingDetails.html';
import controller from './headerLendingDetailsCtrl';
import './style.scss';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    lendingDetails: '<',
  },
};
